module.exports = __webpack_public_path__ + "static/img/A98.59c1c6b3.jpg";